import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { DataTestModule } from '@app/shared/directive/data-test';
import { IconComponent } from '@app/tw-shared/components';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-btn-download-mobile-app',
    templateUrl: './btn-download-mobile-app.component.html',
    styleUrls: ['./btn-download-mobile-app.component.scss'],
    imports: [CommonModule, DataTestModule, IconComponent, TranslateModule],
})
export class BtnDownloadMobileAppComponent {
    @Input() mobileType!: 'android' | 'ios';

    btnConfig: Record<'android' | 'ios', { link: string; icon: IconType; label: string }> = {
        android: {
            link: 'https://play.google.com/store/apps/details?id=com.socialtalent.perform',
            icon: 'google-store',
            label: marker('google-store-button-label'),
        },
        ios: {
            link: 'https://itunes.apple.com/eg/app/socialtalent/id1383707780',
            icon: 'apple-store',
            label: marker('apple-store-button-label'),
        },
    };
}
